import React from "react";
import { VariantBase } from "scmp-sdk/components/newsletter/newsletter-widget/variants/component";

import { Container, theme } from "./styles";
export { config as newsletterArticleThemeConfig } from "./config";

export const NewsletterArticleTheme: React.FunctionComponent<{ children?: React.ReactNode }> = ({
  children,
  ...props
}) => (
  <VariantBase theme={theme}>
    <Container {...props}>{children}</Container>
  </VariantBase>
);

NewsletterArticleTheme.displayName = "NewsletterArticleTheme";
